import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { GetMainUserPhotosRegimenClassEnum, InstantCheckup } from '@cureskin/api-client/src/server-api';
import { AiDetectionCanvasComponent } from 'client/app/report/components/ai-detection-canvas/ai-detection-canvas.component';
import { IncompleteChatClass, IncompleteChatBannerService } from './incomplete-chat-banner.service';

@Component({
  selector: 'app-incomplete-chat-rebranded',
  templateUrl: './incomplete-chat-rebranded.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AiDetectionCanvasComponent],
})
export class IncompleteChatRebrandedComponent {
  private readonly incompleteChatBannerService = inject(IncompleteChatBannerService);

  readonly concernClass = input.required<IncompleteChatClass>();
  readonly displayConcern = input<string>('');

  readonly photo = computed((): InstantCheckup | null => this.incompleteChatBannerService.getPhoto(this.concernClass()));
  readonly isHair = computed((): boolean => this.concernClass() === GetMainUserPhotosRegimenClassEnum.HAIR);
  readonly excludeList = this.incompleteChatBannerService.getExcludeList();
  readonly mainConcern = computed((): string | undefined => this.incompleteChatBannerService.getFaceMainConcern());
}
